export default "__VITE_ASSET__DcL1mVUH__"